import { useContext, useEffect, useState } from 'react';
import { CheckPicker, Notification, Placeholder , useToaster } from 'rsuite';
import { Auth } from '../../../Contexts/AuthContext';
import cancel from '../../../favicon/cancel.svg'
import invitation_sent from '../../../favicon/invitation_sent.gif'
import { APIRequest, ApiUrl } from '../../../Helpers/ApiHelper';
import hasError from '../../../Helpers/ErrorHelper';
import CustomLoader from '../../comman/Loader/CustomLoader';
import Select from 'react-select';
import colourStyles from '../../../Helpers/colourStyles';

const PagesModal = ({ ...props }) => {
    const { showModal, setShowModal, myPages, facebookAccessToken, accessData, influencer_id } = props;
    const { formData } = useContext(Auth);
    const [isLoading, setIsLoading] = useState(false);
    const [pagesAdded, setPagesAdded] = useState(false);
    const [selectedFacebookPage, setSelectedFacebookPage] = useState('');
    const [message, setMessage] = useState('');
    const toaster = useToaster();

    const signUpViaFacebookAuth = () => {
        if (selectedFacebookPage === '') {
            toaster.push(<Notification type="error" header="Error" >
                <Placeholder.Paragraph style={{ width: 100, color: 'red' }} rows={0} />  Please provide on facebook page that is link to Instagram </Notification>
                , {
                    placement: 'topEnd'
                });
        }
        setIsLoading(true);
        let config = {
            url: ApiUrl.signUpViaFacebookAuth,
            method: 'POST',
            body: {
                ...formData,
                'influencer_id': influencer_id,
                'page_id': selectedFacebookPage,
                'accessToken': facebookAccessToken,
                'accessData': accessData,
            }
        }

        APIRequest(
            config,
            res => {
                setIsLoading(false);
                setPagesAdded(true);
                setMessage(res?.message)

            },
            err => {
                setIsLoading(false);
                if (err?.response?.status === 401 || err?.response?.status === 444) {
                    console.log(err);
                    toaster.push(<Notification type="error" header="Error" >
                        <Placeholder.Paragraph style={{ width: 100, color: 'red' }} rows={0} />  {err?.response?.data?.message}</Notification>
                        , {
                            placement: 'topEnd'
                        });

                }
                else {
                    alert(err?.message)
                }
            }
        )
    }



    return (
        <>
            {showModal ? (
                <>
                    <CustomLoader visible={isLoading} />
                    <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

                        <div className="fixed inset-0 z-10 overflow-y-auto">

                            <div className="flex max-h-full justify-center p-4 text-center items-center sm:p-0">

                                <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 ">
                                        <div className="close-modal" onClick={setShowModal}>
                                            <img alt="closemodal" src={cancel} />
                                        </div>
                                        {!pagesAdded ? (
                                            <>
                                                <div className="sm:flex ">
                                                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                        <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Select  your page</h3>
                                                        <div className="mt-2">
                                                            <p className="text-sm text-gray-500">Select your facebook page that is to be linked to your profile .</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="sm:flex ">
                                                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                                                        <div className="mt-2">
                                                            {/* <SelectPicker size='lg' className='hover:border-none' placeholder="Select Your Page" value={selectedFacebookPage} style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px', width: "100%", backgroundColor: "white", border: "none", "borderRadius": "8px", }} onChange={(value) => setSelectedFacebookPage(value)} data={myPages?.map(item => ({ label: item?.name, value: item?.id }))} /> */}
                                                            <Select
                                                                className="joinClass sbar"
                                                                classNamePrefix="joinChild sbar"
                                                                placeholder="How did you hear about us ?"
                                                                styles={colourStyles}
                                                                isClearable={true}
                                                                defaultValue={selectedFacebookPage}
                                                                onChange={(val) => setSelectedFacebookPage(val.value)}
                                                                options={myPages?.map(item => ({ label: item?.name, value: item?.id }))}

                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="">
                                                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                    <div className="mt-2 invited_successfully">
                                                        <p className="text-lg font-museobb text-gray-700">{message}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                    {!pagesAdded && (
                                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                            <button type="button" onClick={(e) => signUpViaFacebookAuth(e)} className="mt-3 inline-flex w-full text-white justify-center rounded-lg border bg-greenBtn px-4 py-2 text-base font-medium shadow-sm hover:bg-greenBtn focus:outline-none  btn-anim i  sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"> Save </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </>
            ) : null}
        </>
    )

};



export default PagesModal;
